import React, { Component } from 'react'
import {
  InputNumber,
  Input,
  message
} from "antd"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

export default class EditTracerModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tracerData: {
        tracer: this.props.detailData.tracer,
        dataTracer: this.props.detailData.datas[0].tracer,
        remark: this.props.detailData.tracerRemark
      }
    }
  }

  updateTracer = () => {
    const { editTracer, getDetailData } = this.props.store
    const { detailData, closeModal } = this.props
    editTracer(this.state.tracerData, detailData.reportId)
      .then(
        res => {
          message.success("标记分子编辑成功")
          getDetailData(detailData.reportId)
          closeModal('editTracerShowed')
        },
        err => {
          message.error(err.message)
        }
      )
  }

  changeHandle = (e, field) => {
    this.setState({
      tracerData: { ...this.state.tracerData, [field]: field !== 'remark' ? e.toString() : e.target.value }
    })
  }

  render() {
    const { closeModal } = this.props
    const { tracerData: { tracer, dataTracer, remark } } = this.state

    return (
      <MaterialModal
        title="编辑标记分子"
        buttonText="保存"
        className="pgs-datamanage-edit-modal"
        visible={true}
        width={550}
        action={() => this.updateTracer()}
        buttonType="primary">
        <img
          className="pgx-modal-close"
          src={closeIcon}
          onClick={() => closeModal('editTracerShowed')}
          alt="关闭对话框"
        />
        <MaterialForm justify="center">
          <MaterialFormItem
            labelText="实际编号"
            labelWidth={60}
            justify="center"
          >
            <InputNumber
              className="sampleName"
              min={0}
              max={300}
              value={tracer ? (tracer !== '' && tracer.trim() === 'NULL' ? '' : tracer) : ''}
              onChange={(e) => this.changeHandle(e, 'tracer')}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="理论编号"
            justify="center"
          >
            <InputNumber
              min={0}
              max={300}
              className="sampleName"
              value={dataTracer || ''}
              onChange={(e) => this.changeHandle(e, 'dataTracer')}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="修改备注"
            justify="center"
          >
            <Input
              className="sampleName"
              value={remark || ''}
              onChange={(e) => this.changeHandle(e, 'remark')}
            />
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/EditTracerModal.js